import template from './income.template.html';

export default {
  template,
  bindings: {
    income: '<',
    incomes: '<',
    contacts: '<',
    validationErrors: '<',
    workflow: '<',
    isTicketSettled: '<',
    isContactIncome: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      helperService,
      incomeService,
      ContactEmploymentType,
      PaymentFrequency
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableIIncomeTypes = [];
      ctrl.availablePaymentFrequencies = [];
      ctrl.availableIncomeLastTaxYears = [];
      ctrl.availableIncomePreviousTaxYears = [];
      ctrl.availableEmployments = [];

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.availableIIncomeTypes = incomeService.getAvailableIncomeTypes();
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          isExpense: false
        });
        ctrl.availableIncomeLastTaxYears = helperService.getAvailableIIncomeLastTaxYears();
        ctrl.availableIncomePreviousTaxYears = helperService.getAvailableIIncomePreviousTaxYears();
        ctrl.income = ctrl.income || {};
        ctrl.incomes = ctrl.incomes || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.personContacts = _.filter(ctrl.contacts || [], (c) => !c?.isCompany);
        ctrl.personSelfEmployed = _.filter(
          ctrl.personContacts,
          (c) => c?.person?.information?.employments || [],
          (e) => e?.type?.name === ContactEmploymentType.self_employed.name
        );
        ctrl.companyContacts = _.filter(ctrl.contacts || [], (c) => c?.isCompany).concat(
          ctrl.personSelfEmployed
        );
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isContactIncome = ctrl.isContactIncome || false;
        ctrl.index = _.findIndex(ctrl.incomes, (i) => i?.id === ctrl.income?.id);
        if (ctrl.income.idContact !== '') {
          ctrl.getAvailableEmployments();
        }
      };

      ctrl.changeTaxYear = (isLastTaxtYear) => {
        if (isLastTaxtYear) {
          ctrl.income.business.previousTaxYear.taxYear = _.subtract(
            ctrl.income?.business?.lastTaxYear?.taxYear,
            1
          );
        } else {
          ctrl.income.business.lastTaxYear.taxYear = _.add(
            ctrl.income?.business?.previousTaxYear?.taxYear,
            1
          );
        }
        ctrl.saveIncome();
      };

      ctrl.filterEmployerType = ({ employment }) => {
        if (ctrl.income?.incomeType.id === ctrl.availableIIncomeTypes[0].id) {
          return employment?.type?.name === ContactEmploymentType.salaried_employee.name;
        }
        if (ctrl.income?.incomeType.id === ctrl.availableIIncomeTypes[1].id) {
          return employment?.type?.name === ContactEmploymentType.self_employed.name;
        }
        return true;
      };

      ctrl.getAvailableEmployments = (isChanged) => {
        const contact = _.find(
          ctrl.contacts,
          (c) => c?.id === ctrl.income?.idContact && !c?.isCompany
        );
        ctrl.availableEmployments = _.filter(
          contact?.person?.employments || [],
          (e) => e?.isCurrent
        );
        if (isChanged) {
          ctrl.saveIncome();
        }
      };

      ctrl.getContact = () => _.find(ctrl.contacts, (c) => c?.id === ctrl.income?.idContact);

      ctrl.showWarning = ({ type }) => {
        switch (type) {
          case 'PAYG':
            return (
              (ctrl.income?.payg?.grossSalary &&
                ctrl.income?.payg?.grossSalaryFrequency?.name === PaymentFrequency.none.name) ||
              (ctrl.income?.payg?.bonus &&
                ctrl.income?.payg?.bonusFrequency?.name === PaymentFrequency.none.name) ||
              (ctrl.income?.payg?.overtimeEssential &&
                ctrl.income?.payg?.overtimeEssentialFrequency?.name ===
                  PaymentFrequency.none.name) ||
              (ctrl.income?.payg?.overtimeNonEssential &&
                ctrl.income?.payg?.overtimeNonEssentialFrequency?.name ===
                  PaymentFrequency.none.name) ||
              (ctrl.income?.payg?.commission &&
                ctrl.income?.payg?.commissionFrequency?.name === PaymentFrequency.none.name) ||
              (ctrl.income?.payg?.allowance &&
                ctrl.income?.payg?.allowanceFrequency?.name === PaymentFrequency.none.name)
            );
          case 'OTHER':
            return (
              ctrl.income?.grossValue &&
              ctrl.income?.frequency?.name === PaymentFrequency.none.name
            );
          default:
            return false;
        }
      };

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.saveIncome = () => {
        ctrl.onFinished({ income: ctrl.income });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
